import React from "react";
import UpdateButton from "@components/FlowActionButtons/UpdateButton";
import type { Task } from "@services/vesselCall/types";
import { canUserUpdate } from "./utils";

interface UpdateVesselCallProps {
  vesselCallFlowData?: {
    vesselCallId: string;
    task: Task | null;
    status: string;
    companyId: string;
  };
  onUpdateVesselCall: () => void;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const UpdateVesselCall: React.FC<UpdateVesselCallProps> = ({
  vesselCallFlowData,
  onUpdateVesselCall,
}) => {
  if (!vesselCallFlowData) {
    return null;
  }

  const isActionAvailable = !!canUserUpdate(
    vesselCallFlowData.status,
    vesselCallFlowData.companyId,
  );

  return (
    <UpdateButton
      langBase={LANG_BASE}
      permission="canUpdateVesselCall"
      isActionAvailable={isActionAvailable}
      onUpdate={onUpdateVesselCall}
      variant="contained"
    />
  );
};
export default UpdateVesselCall;
